<template>
    <div class="compare-with-tag">
        <div
            v-if="type === 'button'"
            class="compare-with-tag__button"
        >
            <button
                class="compare-with-tag__button__inner"
                @click="doCompare"
            >
                <PtIcon icon="CompareGradient" class="compare-with-tag__button__icon" />
                <span>{{ $t('patent-view.compareView.compareWithCurrent') }}</span>
            </button>
        </div>

        <ElTooltip
            v-else
            :visible-arrow="false"
            :enterable="false"
            :content="$t('patent-view.compareView.compareWithCurrent')"
            :openDelay="POPPER_OPEN_DELAY"
            placement="top">
            <PtIcon
                icon="CompareGradient"
                class="compare-with-tag__tag"
                @click.stop="doCompare" />
        </ElTooltip>
    </div>
</template>

<script lang="ts">
import { Tooltip } from 'element-ui';
import { Icon } from 'patsnap-biz';
import { POPPER_OPEN_DELAY } from '@/constants';
import { FetchCompareInit } from '@/infrastructure/api-functions/core-search-api/core-search-api-service.interface';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import _ from 'lodash';
import '@patsnap-ui/icon/assets/CompareGradient.svg';
import { RavenInsertMeta } from 'library-@/services/sentry';

export default {
    name: 'CompareWithTag',
    components: {
        ElTooltip: Tooltip,
        PtIcon: Icon
    },
    props: {
        type: {
            type: String,
            default: 'button'
        },
        sourcePatentId: {
            type: String
        },
        targetPatentId: {
            type: String
        },
        relatedId: {
            type: String
        },
        searchType: {
            type: String
        },
        familyType: {
            type: String
        },
        affectType: {
            type: String
        },
        otherParams: {
            type: Object,
            default: () => ({})
        },
        iconColor: {
            type: String,
        },
        page: {
            type: Number,
            default: 1,
        },
        rows: {
            type: Number,
            default: 20
        }
    },
    data() {
        return {
            isLoading: false,
            POPPER_OPEN_DELAY
        };
    },
    methods: {
        async doCompare() {
            if (this.isLoading) return;
            RavenInsertMeta('View', 'Enter Patent Comparison From View');
            const service = injectService<FetchCompareInit>(FetchCompareInit);
            service.fetchCompareInit({
                related_id: this.relatedId,
                family_type: this.familyType,
                affect_type: this.affectType,
                type: this.searchType as string,
                sort_type: this.otherParams?.sort_type,
                sort_order: this.otherParams?.sort_order,
                semantic_id: this.otherParams?.semanticId,
            }).then(res => {
                const compareId = _.get(res, 'compare_id', '');
                if (compareId) {
                    const href = `/patent-view/clms'clms/${this.sourcePatentId}'${this.targetPatentId}?compareId=${compareId}&page=${this.page}&rows=${this.rows}&_type=${this.searchType}`;
                    const newTab = window.open();
                    newTab!.opener = null;
                    newTab!.location = href;
                }
            })
        }
    }
};
</script>

<style lang="scss">
.compare-with-tag {
    display: block;
    .compare-with-tag__tag {
        background-color: $green-primary;
        border-radius: 4px;
        cursor: pointer;
    }

    .compare-with-tag__button {
        cursor: pointer;
        border-radius: 4px;
        background-image: linear-gradient(0deg, #0a3dff, #0dacba, #18ec81);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        padding: 1px;

        &__inner {
            height: 100%;
            width: 100%;
            border-radius: 4px;
            padding: 0px 16px 0 8px;
            line-height: 24px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &:hover {
            .compare-with-tag__button__inner {
                background: #ebecf0;
            }
        }
        &__icon {
            margin-right: 4px;
            font-size: 24px;
        }
    }

}
</style>
